@let modal = errorState.errorModal();

<div class="errorMessage er500" id="error-dialog" role="alertdialog" aria-labelledby="error-dialog-title" aria-describedby="error-dialog-message" aria-modal="true" tabindex="-1" (keydown.escape)="errorState.closeError()" [style.display]="modal.visible ? 'block' : 'none'">
  <div class="errorFrame">
    <h3 id="error-dialog-title">Get My Report</h3>
    <button type="button" id="btn-error-reload" class="closeError" [attr.aria-label]="'itgen_gmr_close_window' | translate | decodeEntities" [title]="'itgen_gmr_close_window' | translate | decodeEntities" (click)="reloadPage()"></button>
    <div class="errorBody">
      <div class="errorHero">
        <div class="statusContainer">
          <img src="images/error.svg" class="statusIcon" alt="" aria-hidden="true" width="48" height="48" />
          <span id="error-dialog-code" class="messageSpan">{{ modal.messageCode }}</span>
        </div>
        <div class="errorText">
          <span id="error-dialog-message" class="message"><app-linked-text [parts]="splitWebAddresses(modal.message)" /></span>
          <!-- The kind request: what the user can do about it. Not shown when the error carries none. -->
          @if (modal.showKindRequest)
          {
            <div class="todoBlock">
              <svg class="todoIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0 0 12 3z"/></svg>
              <div>
                <span class="todoLabel" translate="itgen_gmr_what_you_can_do"></span>
                <span class="kindRequest"><app-linked-text [parts]="splitWebAddresses(modal.kindRequest)" /></span>
              </div>
            </div>
          }
        </div>
      </div>
      <!-- Request ID: what support asks for. Not translated, as the label of the error page of the Data
           Access Point and the name of the header it comes from. Not shown when there is none. -->
      <div class="errorRefs">
        @if (modal.requestId)
        {
          <p class="uidWrapper">
            <span class="requestIDLabel">Request ID</span><span class="requestID">{{ modal.requestId }}</span>
            <button type="button" id="btn-error-copy-request-id" class="iconBtn" [class.copied]="copiedTarget() === 'requestId'" [title]="'itgen_gmr_copy_request_id' | translate | decodeEntities" [attr.aria-label]="'itgen_gmr_copy_request_id' | translate | decodeEntities" (click)="copyRequestId()"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V6a2 2 0 0 1 2-2h8"/></svg></button>
          </p>
        }
        @if (modal.showNaturalKeyWrapper)
        {
          <p class="naturalKeyWrapper">
            <span class="naturalKeyLabel" translate="itgen_gmr_natural_key"></span><span class="naturalKey">{{ modal.naturalKey }}</span>
          </p>
        }
      </div>
      @if (tips().length > 0)
      {
        <div class="helpTips">
          <h4 translate="itgen_related_forums_topics"></h4>
          <ul class="tipLinks">
            @for (tip of tips(); track tip.url; let tipIndex = $index)
            {
              <li class="hintsContent">
                <a [id]="'link-error-tip-' + tipIndex" [href]="tip.url" target="_blank" rel="noopener">
                  @switch (tip.kind)
                  {
                    @case ('article')
                    {
                      <svg class="tipIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3z"/><path d="M5 17a3 3 0 0 1 3-3h11"/></svg>
                    }
                    @case ('answered')
                    {
                      <svg class="tipIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.7 2.7L16 9.5"/></svg>
                    }
                    @default
                    {
                      <svg class="tipIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.7.4-1 .9-1 1.7M12 17h.01"/></svg>
                    }
                  }
                  <span class="tipTitle">{{ tip.title }}</span>
                  @if (tip.otherLanguage)
                  {
                    <span class="tipLang" [attr.lang]="tip.otherLanguage">{{ tip.otherLanguage.toUpperCase() }}</span>
                  }
                  <span class="tipExternal" aria-hidden="true"></span>
                </a>
              </li>
            }
          </ul>
        </div>
      }
      @let support = 'itgen_gmr_question_forums_dot' | translate;
      <div class="supportNote">
        <span class="supportIcon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M4 5h16v11H9l-5 4z"/><path d="M8 9h8M8 12h5"/></svg></span>
        <p class="supportText"><app-linked-text [parts]="splitForumsHost(support)" /></p>
      </div>
      <div class="errorDetails" id="error-details" role="group" aria-labelledby="btn-error-details" [hidden]="!detailsOpen()">
        <div class="detailsHead">
          <button type="button" id="btn-error-copy" class="barBtn" [class.copied]="copiedTarget() === 'message'" (click)="copyMessage()"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V6a2 2 0 0 1 2-2h8"/></svg><span class="copyLabel">{{ (copiedTarget() === 'message' ? 'itgen_gmr_error_copied' : 'itgen_gmr_copy_message') | translate }}</span></button>
        </div>
        <dl class="detailsList">
          @if (modal.uid)
          {
            <div class="detailRow uidRow"><dt translate="itgen_message_id"></dt><dd class="uid">{{ modal.uid }}</dd></div>
          }
          @if (modal.timeOccurredUtc)
          {
            <div class="detailRow occurredRow"><dt translate="itgen_occurred_utc"></dt><dd class="detailOccurred">{{ modal.timeOccurredUtc }}</dd></div>
          }
          <!-- Which request failed and with what status. Not translated: a URL and an HTTP status are the same
               in every language, and this row is meant to be copied into a report verbatim. -->
          @if (modal.showRequestWrapper)
          {
            <div class="detailRow requestWrapper"><dt translate="itgen_request"></dt><dd class="requestUrl">{{ modal.requestStatus }} {{ modal.requestUrl }}</dd></div>
          }
        </dl>
      </div>
    </div>
    <div class="errorBar">
      <button type="button" id="btn-error-details" class="detailsToggle" [attr.aria-expanded]="detailsOpen()" aria-controls="error-details" (click)="toggleDetails()"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6"/></svg><span translate="itgen_gmr_details"></span></button>
      <span class="barSpacer"></span>
      <!-- Only for an error the service marks as recoverable, which is the one a second attempt can solve. -->
      @if (modal.isRecoverable)
      {
        <button type="button" id="btn-error-reload-page" class="barBtn" (click)="reloadPage()"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20 11a8 8 0 1 0-2.3 5.7M20 5v6h-6"/></svg><span translate="itgen_gmr_reload_page"></span></button>
      }
      <button type="button" id="btn-error-ok" class="closeBtn" (click)="errorState.closeError()">OK</button>
    </div>
  </div>
  <span id="error-copy-status" class="visuallyHidden" role="status" aria-live="polite">{{ copiedTarget() ? ('itgen_gmr_error_copied' | translate) : '' }}</span>
</div>
